import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from './contexts/AuthContext';

// Import pages
import LandingPage from './pages/LandingPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import SetPasswordPage from './pages/SetPasswordPage';
import IntroductionPage from './pages/IntroductionPage';
import WelcomePage from './pages/WelcomePage';
import PrivacyNoticePage from './pages/PrivacyNoticePage';
import PaymentPage from './pages/PaymentPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentCancelledPage from './pages/PaymentCancelledPage';
import JournalingPage from './pages/JournalingPage';
import SettlingInPage from './pages/SettlingInPage';
import VideoBreakPage from './pages/VideoBreakPage';
import InterpretationPage from './pages/InterpretationPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboard from './pages/AdminDashboard';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';
import DoNotSellPage from './pages/DoNotSellPage';
import CookieBanner from './components/CookieBanner';

// Import protected route component
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LandingPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/set-password" element={<SetPasswordPage />} />
          <Route path="/introduction" element={<IntroductionPage />} />
          <Route path="/welcome" element={<WelcomePage />} />
          <Route path="/privacy-notice" element={<PrivacyNoticePage />} />
          <Route path="/payment" element={<PaymentPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/do-not-sell" element={<DoNotSellPage />} />
          
          {/* Journaling Experience - Protected Routes */}
          <Route path="/settling-in" element={
            <ProtectedRoute requirePayment={true}>
              <SettlingInPage />
            </ProtectedRoute>
          } />
          <Route path="/journaling" element={
            <ProtectedRoute requirePayment={true}>
              <JournalingPage />
            </ProtectedRoute>
          } />
          <Route path="/video-break" element={
            <ProtectedRoute requirePayment={true}>
              <VideoBreakPage />
            </ProtectedRoute>
          } />
          <Route path="/interpretation" element={
            <ProtectedRoute requirePayment={true} allowLifetimeAccess={true}>
              <InterpretationPage />
            </ProtectedRoute>
          } />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
          
          {/* Payment redirect pages */}
          <Route path="/payment-success" element={<PaymentSuccessPage />} />
          <Route path="/payment-cancelled" element={<PaymentCancelledPage />} />
          
          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
